import { useCallback, useEffect, useState } from "react";
const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleWindowResize = useCallback(() => {
        setWindowWidth(window.innerWidth);
    }, []);
    useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, [handleWindowResize]);
    return windowWidth;
};
export default useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map